import { Colors } from "@template/style";

const styles = {
  header: { bgcolor: Colors.MAIN_GREEN_LIGHT },
} as const;

export default styles;
